import React, { useState } from 'react';
import { useQuery } from '@apollo/react-hooks';
import * as S from './styles';
import { IProps } from './types';
import { meForPoint, meForPointVariables } from './__generated__/meForPoint';
import { ME_FOR_POINT } from './queries';
import { BreadCrumb, Loading } from '@atoms';
import { Table, Container, Row, Col, Card } from 'react-bootstrap';
import { getPrice, getDBIdFromGraphqlId } from '@utils';
import { OffsetPagination } from '@molecules';
import { useAlert } from 'react-alert';
import { accountUrl } from '@src/app/routes';

const MyPointPage: React.FC<IProps> = ({}: IProps) => {
  const eventsToShow = 10;
  const initialVariables = { first: eventsToShow };
  const [variables, setVariables] = useState<meForPointVariables>(initialVariables);

  const alert = useAlert();
  const { data, error, loading } = useQuery<meForPoint>(ME_FOR_POINT, {
    variables,
  });

  const breadCrumbData = [
    {
      name: 'My Account',
      link: accountUrl,
    },
    {
      name: 'My Point',
    },
  ];

  return (
    (data && (
      <S.Wrapper>
        <BreadCrumb data={breadCrumbData} />
        <S.HeaderWrapper>
          <S.Header>My points</S.Header>
        </S.HeaderWrapper>
        <S.Subtitle>SUMMARY</S.Subtitle>
        <Container>
          <Row>
            <S.MyPointPageCard>
              <Card.Body>
                <Row>
                  <Col md={6} xs={6} style={{ borderRight: '1px solid rgba(0, 0, 0, 0.125)' }}>
                    <S.SummaryTitle>Available</S.SummaryTitle>
                    <S.SummaryValue>{getPrice(data.me.point?.availableAmount, false)}</S.SummaryValue>
                  </Col>
                  <Col md={6} xs={6}>
                    <S.SummaryTitle>Earned</S.SummaryTitle>
                    <S.SummaryValue>{getPrice(data.me.point?.earnedAmount, false)}</S.SummaryValue>
                  </Col>
                </Row>
                <S.BottomRow>
                  <S.BottomCol md={6} xs={6} style={{ borderRight: '1px solid rgba(0, 0, 0, 0.125)' }}>
                    <S.SummaryTitle>Used</S.SummaryTitle>
                    <S.SummaryValue>{getPrice(data.me.point?.usedAmount, false)}</S.SummaryValue>
                  </S.BottomCol>
                  <S.BottomCol md={6} xs={6}>
                    <S.SummaryTitle>Expired</S.SummaryTitle>
                    <S.SummaryValue>{getPrice(data.me.point?.expiredAmount, false)}</S.SummaryValue>
                  </S.BottomCol>
                </S.BottomRow>
              </Card.Body>
            </S.MyPointPageCard>
          </Row>
        </Container>
        <S.Subtitle>HISTORY</S.Subtitle>
        {data.me.pointEvents.edges.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <td>Event</td>
                <td>Date</td>
                <td>Type</td>
                <td>Amount</td>
                <td>Expiry date</td>
                <td>Description</td>
              </tr>
            </thead>
            <tbody>
              {data?.me?.pointEvents?.edges?.map((edge, i) => {
                const point = edge.node;
                return (
                  <tr key={i}>
                    <td>#{getDBIdFromGraphqlId(point.id)}</td>
                    <td style={{ whiteSpace: 'nowrap' }}>{point.createdAt}</td>
                    <td>{point.type}</td>
                    <td>{point.amount}</td>
                    <td style={{ whiteSpace: 'nowrap' }}>{point.expiringDate}</td>
                    <td>{point.description}</td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        ) : (
          <S.NoDataCol>
            <S.NoData>THERE ARE NOT ANY POINT HISTORY.</S.NoData>
          </S.NoDataCol>
        )}
        <OffsetPagination
          itemsToShow={eventsToShow}
          startCursor={data.me.pointEvents.pageInfo.startCursor}
          totalCount={data.me.pointEvents.totalCount}
          setVariables={setVariables}
        />
      </S.Wrapper>
    )) || <Loading />
  );
};

export { MyPointPage };
